// source: pbtypes/gen/planner/gimbal_roll_command.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.planner.GimbalRollCommand', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.GimbalRollCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.planner.GimbalRollCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.GimbalRollCommand.displayName = 'proto.planner.GimbalRollCommand';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.GimbalRollCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.GimbalRollCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.GimbalRollCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.GimbalRollCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
gimbalRoll: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
gimbalRollAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
gimbalRollRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
gimbalRollRateAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
maxGimbalRollRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.GimbalRollCommand}
 */
proto.planner.GimbalRollCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.GimbalRollCommand;
  return proto.planner.GimbalRollCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.GimbalRollCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.GimbalRollCommand}
 */
proto.planner.GimbalRollCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalRoll(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalRollAggressiveness(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalRollRate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalRollRateAggressiveness(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxGimbalRollRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.GimbalRollCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.GimbalRollCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.GimbalRollCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.GimbalRollCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getGimbalRoll();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getGimbalRollAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getGimbalRollRate();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getGimbalRollRateAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getMaxGimbalRollRate();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float gimbal_roll = 2;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getGimbalRoll = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setGimbalRoll = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float gimbal_roll_aggressiveness = 3;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getGimbalRollAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setGimbalRollAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float gimbal_roll_rate = 4;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getGimbalRollRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setGimbalRollRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float gimbal_roll_rate_aggressiveness = 5;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getGimbalRollRateAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setGimbalRollRateAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float max_gimbal_roll_rate = 6;
 * @return {number}
 */
proto.planner.GimbalRollCommand.prototype.getMaxGimbalRollRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.GimbalRollCommand} returns this
 */
proto.planner.GimbalRollCommand.prototype.setMaxGimbalRollRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


goog.object.extend(exports, proto.planner);
